// Simple event emitter for permissions updates
type PermissionsUpdateListener = () => void;

class PermissionsEventEmitter {
  private listeners: PermissionsUpdateListener[] = [];

  subscribe(listener: PermissionsUpdateListener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  emit() {
    this.listeners.forEach((listener) => listener());
  }
}

export const permissionsEvents = new PermissionsEventEmitter();
